module.exports = __webpack_public_path__ + "img/1559623897.43f37fbf.jpg";